var _path, _line, _line2, _line3, _line4, _line5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubtitles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1248 20.3692C27.1248 21.0543 27.2753 22.171 26.7908 22.6555C26.3063 23.14 25.2266 22.9525 24.5415 22.9525H9.04146L3.8748 28.1192V7.45252C3.8748 6.76737 3.81605 5.73329 4.30052 5.24883C4.78499 4.76436 5.77299 4.86918 6.45813 4.86918H24.5415C25.2266 4.86918 26.3063 4.76436 26.7908 5.24883C27.2753 5.73329 27.1248 6.76737 27.1248 7.45252V20.3692Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.70166,
    y1: 11.7281,
    x2: 17.5581,
    y2: 11.7281,
    stroke: "white",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 2.74458,
    y2: -1,
    transform: "matrix(1 5.63096e-06 -9.3947e-06 1 19.2881 12.7281)",
    stroke: "white",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 2.74458,
    y2: -1,
    transform: "matrix(1 5.63096e-06 -9.39471e-06 1 8.70215 16.8842)",
    stroke: "white",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 2.74458,
    y2: -1,
    transform: "matrix(1 5.63096e-06 -9.39471e-06 1 12.7651 16.8842)",
    stroke: "white",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 5.37163,
    y2: -1,
    transform: "matrix(1 5.63096e-06 -9.3947e-06 1 16.6606 16.8842)",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitles);
export default __webpack_public_path__ + "static/media/SUBTITLES.c818c3fadb8342309994eb303dbf78f4.svg";
export { ForwardRef as ReactComponent };